
(function () {
  'use strict';

  /*
   * TOP CUT TAVERN
   * Universal Card Hall Search
   * Magic / Pokemon / Star Wars Unlimited
   */

  const GAME_TYPES = {
    mtg: 'Magic: The Gathering Singles',
    pokemon: 'Pokemon Singles',
    swu: 'Star Wars Unlimited Singles'
  };

  const ALL_COLORS = [
    'White',
    'Blue',
    'Black',
    'Red',
    'Green',
    'Colorless'
  ];

  const FILTER_NAMES = [
    'tct_set',
    'tct_color',
    'tct_energy',
    'tct_aspect',
    'tct_rarity',
    'tct_type'
  ];

  /* ============================
     HELPERS
     ============================ */

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function normalizeProductType(value) {
    return normalize(value)
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function getGame(form) {
    const game = form.dataset.game;

    if (GAME_TYPES[game]) {
      return game;
    }

    const params = new URLSearchParams(
      window.location.search
    );

    const query = normalizeProductType(
      params.get('q') || ''
    );

    if (query.includes('pokemon singles')) {
      return 'pokemon';
    }

    if (query.includes('star wars unlimited singles')) {
      return 'swu';
    }

    return 'mtg';
  }

  function getProductType(form) {
    return GAME_TYPES[getGame(form)];
  }

  function escapeHtml(value) {
    const div = document.createElement('div');

    div.textContent = String(
      value == null ? '' : value
    );

    return div.innerHTML;
  }

  function quoteValue(value) {
    return '"' + String(value || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"') + '"';
  }

  function checkedValues(form, name) {
    return Array.from(
      form.querySelectorAll(
        '[name="' + name + '"]:checked'
      )
    ).map(input => input.value);
  }

  function orGroup(field, values) {
    if (!values.length) {
      return '';
    }

    const clauses = values.map(value => {
      return field + ':' + quoteValue(value);
    });

    if (clauses.length === 1) {
      return clauses[0];
    }

    return '(' + clauses.join(' OR ') + ')';
  }

  function searchTokens(value) {
    return (
      String(value || '').match(/"[^"]+"|\S+/g) || []
    )
      .map(token => {
        return token
          .replace(/^"|"$/g, '')
          .trim();
      })
      .filter(Boolean);
  }

  function getSearchRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function getSearchPath() {
    return getSearchRoot() + 'search';
  }

  /* ============================
     BUILD SHOPIFY SEARCH QUERY
     ============================ */

  function buildShopifyQuery(form) {
    const clauses = [];

    const game = getGame(form);
    const productType = getProductType(form);

    // Require the selected game's product type.
    clauses.push(
      'product_type:' + quoteValue(productType)
    );

    // Search card title and description.
    const textInput = form.querySelector(
      '[name="tct_text"]'
    );

    const tokens = searchTokens(
      textInput ? textInput.value : ''
    );

    tokens.forEach(token => {
      clauses.push(
        '(title:' + quoteValue(token) +
        ' OR body:' + quoteValue(token) + ')'
      );
    });

    // Set, rarity, card type.
    [
      'tct_set',
      'tct_rarity',
      'tct_type'
    ].forEach(name => {
      const clause = orGroup(
        'tag',
        checkedValues(form, name)
      );

      if (clause) {
        clauses.push(clause);
      }
    });

    /* MAGIC COLORS */

    if (game === 'mtg') {
      const colors = checkedValues(
        form,
        'tct_color'
      );

      const modeInput = form.querySelector(
        '[name="tct_color_mode"]:checked'
      );

      const mode = modeInput
        ? modeInput.value
        : 'contains';

      if (colors.length) {

        // Must contain every selected color.
        if (
          mode === 'contains' ||
          mode === 'exact'
        ) {
          colors.forEach(color => {
            clauses.push(
              'tag:' + quoteValue(color)
            );
          });
        }

        // No other colors allowed.
        if (mode === 'exact') {
          ALL_COLORS.forEach(color => {
            if (!colors.includes(color)) {
              clauses.push(
                'NOT tag:' + quoteValue(color)
              );
            }
          });
        }

        // Exclude selected colors.
        if (mode === 'exclude') {
          colors.forEach(color => {
            clauses.push(
              'NOT tag:' + quoteValue(color)
            );
          });
        }
      }
    }

    /* POKEMON ENERGY */

    if (game === 'pokemon') {
      const energyClause = orGroup(
        'tag',
        checkedValues(form, 'tct_energy')
      );

      if (energyClause) {
        clauses.push(energyClause);
      }
    }

    /* STAR WARS UNLIMITED ASPECTS */

    if (game === 'swu') {
      const aspectClause = orGroup(
        'tag',
        checkedValues(form, 'tct_aspect')
      );

      if (aspectClause) {
        clauses.push(aspectClause);
      }
    }

    // Explicit AND prevents OR groups from
    // matching unrelated product types.
    return clauses.join(' AND ');
  }

  /* ============================
     BUILD SEARCH URL
     ============================ */

  function buildSearchUrl(form) {
    const params = new URLSearchParams();

    const productType = getProductType(form);

    params.set(
      'q',
      buildShopifyQuery(form)
    );

    params.set('type', 'product');

    // Restrict results by product type.
    params.set(
      'filter.p.product_type',
      productType
    );

    // Hide unavailable products.
    params.set(
      'options[unavailable_products]',
      'hide'
    );

    // Availability storefront filter,
    // where enabled in Shopify.
    params.set(
      'filter.v.availability',
      '1'
    );

    // Keep the selected game.
    params.set(
      'tct_game',
      getGame(form)
    );

    // Save card text for reloading UI.
    const textInput = form.querySelector(
      '[name="tct_text"]'
    );

    if (textInput && textInput.value.trim()) {
      params.set(
        'tct_text',
        textInput.value.trim()
      );
    }

    // Save selected filters.
    FILTER_NAMES.forEach(name => {
      checkedValues(form, name).forEach(value => {
        params.append(name, value);
      });
    });

    // Save MTG color mode.
    if (getGame(form) === 'mtg') {
      const modeInput = form.querySelector(
        '[name="tct_color_mode"]:checked'
      );

      if (modeInput) {
        params.set(
          'tct_color_mode',
          modeInput.value
        );
      }
    }

    // Preserve sorting and page size.
    const currentUrl = new URL(
      window.location.href
    );

    ['sort_by', 'view'].forEach(name => {
      const value = currentUrl.searchParams.get(name);

      if (value) {
        params.set(name, value);
      }
    });

    const action = form.getAttribute('action') ||
      getSearchPath();

    return action + '?' + params.toString();
  }

  /* ============================
     RESTORE FILTER STATE
     ============================ */

  function restoreFormState(form) {
    const params = new URLSearchParams(
      window.location.search
    );

    const textInput = form.querySelector(
      '[name="tct_text"]'
    );

    if (
      textInput &&
      params.has('tct_text')
    ) {
      textInput.value = params.get('tct_text');
    }

    FILTER_NAMES.forEach(name => {
      const values = params.getAll(name);

      form.querySelectorAll(
        '[name="' + name + '"]'
      ).forEach(input => {
        input.checked = values.includes(
          input.value
        );
      });
    });

    const mode = params.get(
      'tct_color_mode'
    );

    if (mode) {
      form.querySelectorAll(
        '[name="tct_color_mode"]'
      ).forEach(input => {
        input.checked = input.value === mode;
      });
    }

    // Reopen selected categories.
    FILTER_NAMES.forEach(name => {
      const checked = form.querySelector(
        '[name="' + name + '"]:checked'
      );

      if (checked) {
        const group = checked.closest('details');

        if (group) {
          group.open = true;
        }
      }
    });
  }

  /* ============================
     SET SEARCH
     ============================ */

  function initializeSetSearch(form) {
    const input = form.querySelector(
      '[data-set-search]'
    );

    const choices = Array.from(
      form.querySelectorAll(
        '[data-set-choice]'
      )
    );

    const noResults = form.querySelector(
      '[data-set-no-results]'
    );

    if (!input) {
      return;
    }

    input.addEventListener('input', function () {
      const query = normalize(input.value);
      let visibleCount = 0;

      choices.forEach(choice => {
        const name = normalize(
          choice.dataset.setName
        );

        const matches =
          !query || name.includes(query);

        choice.hidden = !matches;

        if (matches) {
          visibleCount++;
        }
      });

      if (noResults) {
        noResults.hidden = visibleCount > 0;
      }
    });
  }

  /* ============================
     FORMAT PRICE
     ============================ */

  function formatMoney(value) {
    const amount = Number(value);

    if (!Number.isFinite(amount)) {
      return '';
    }

    let currency = 'USD';

    if (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
    ) {
      currency = window.Shopify.currency.active;
    }

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang ||
        'en-US',
        {
          style: 'currency',
          currency: currency
        }
      ).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  /* ============================
     PREDICTIVE SEARCH
     ============================ */

  function initializePredictiveSearch(form) {
    const input = form.querySelector(
      '[data-card-text-input]'
    );

    const results = form.querySelector(
      '[data-card-text-results]'
    );

    if (!input || !results) {
      return;
    }

    let timer = null;
    let controller = null;

    function hideResults() {
      results.hidden = true;
    }

    function viewAllLink() {
      return (
        '<a class="tct-predictive-view-all" href="' +
        escapeHtml(buildSearchUrl(form)) +
        '">View All Filtered Results</a>'
      );
    }

    async function runPredictiveSearch(term) {
      if (controller) {
        controller.abort();
      }

      const request = new AbortController();
      controller = request;

      results.hidden = false;

      results.innerHTML =
        '<p class="tct-predictive-message">' +
        'Searching the Card Hall…</p>';

      const params = new URLSearchParams();

      params.set('q', term);

      params.set(
        'resources[type]',
        'product'
      );

      params.set(
        'resources[limit]',
        '10'
      );

      params.set(
        'resources[limit_scope]',
        'each'
      );

      params.set(
        'resources[options][unavailable_products]',
        'hide'
      );

      params.set(
        'resources[options][fields]',
        'title,body'
      );

      try {
        const response = await fetch(
          getSearchRoot() +
            'search/suggest.json?' +
            params.toString(),
          {
            signal: request.signal
          }
        );

        if (!response.ok) {
          throw new Error(
            'Predictive search failed'
          );
        }

        const data = await response.json();

        const products =
          data &&
          data.resources &&
          data.resources.results &&
          data.resources.results.products
            ? data.resources.results.products
            : [];

        const matchingProducts = products.filter(
          product => {
            return (
              normalizeProductType(product.type) ===
              normalizeProductType(
                getProductType(form)
              )
            );
          }
        );

        if (!matchingProducts.length) {
          results.innerHTML =
            '<p class="tct-predictive-message">' +
            'No quick suggestions found. ' +
            'Try the full search.</p>' +
            viewAllLink();

          return;
        }

        let html = '';

        matchingProducts.forEach(product => {
          let imageUrl = '';

          if (product.featured_image) {
            imageUrl =
              product.featured_image.url ||
              product.featured_image;
          } else if (product.image) {
            imageUrl = product.image;
          }

          let imageHtml =
            '<span class="tct-predictive-card__image"></span>';

          if (
            typeof imageUrl === 'string' &&
            imageUrl
          ) {
            imageHtml =
              '<img class="tct-predictive-card__image" ' +
              'src="' + escapeHtml(imageUrl) + '" ' +
              'alt="" loading="lazy">';
          }

          html +=
            '<a class="tct-predictive-card" href="' +
            escapeHtml(product.url || '#') +
            '">' +
            imageHtml +
            '<span>' +
            '<span class="tct-predictive-card__title">' +
            escapeHtml(product.title) +
            '</span>' +
            '<span class="tct-predictive-card__price">' +
            escapeHtml(
              formatMoney(product.price)
            ) +
            '</span>' +
            '</span>' +
            '</a>';
        });

        results.innerHTML =
          html + viewAllLink();

      } catch (error) {
        if (error.name === 'AbortError') {
          return;
        }

        results.innerHTML =
          '<p class="tct-predictive-message">' +
          'Quick search is unavailable. ' +
          'Use the full search.</p>' +
          viewAllLink();
      }
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);

      const term = input.value.trim();

      if (term.length < 2) {
        if (controller) {
          controller.abort();
        }

        hideResults();
        results.innerHTML = '';
        return;
      }

      timer = setTimeout(function () {
        runPredictiveSearch(term);
      }, 250);
    });

    form.addEventListener('change', function () {
      const link = results.querySelector(
        '.tct-predictive-view-all'
      );

      if (link) {
        link.href = buildSearchUrl(form);
      }
    });

    document.addEventListener(
      'click',
      function (event) {
        if (!form.contains(event.target)) {
          hideResults();
        }
      }
    );

    input.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'Escape') {
          hideResults();
        }
      }
    );
  }

  /* ============================
     FILTER FORM
     ============================ */

  function initializeFilterForm(form) {
    restoreFormState(form);
    initializeSetSearch(form);
    initializePredictiveSearch(form);

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();

        window.location.assign(
          buildSearchUrl(form)
        );
      }
    );

    const clearButton = form.querySelector(
      '[data-clear-card-filters]'
    );

    if (clearButton) {
      clearButton.addEventListener(
        'click',
        function () {
          const game = getGame(form);
          const type = GAME_TYPES[game];

          const params = new URLSearchParams();

          params.set(
            'q',
            'product_type:' + quoteValue(type)
          );

          params.set('type', 'product');

          params.set('tct_game', game);

          params.set(
            'filter.p.product_type',
            type
          );

          params.set(
            'options[unavailable_products]',
            'hide'
          );

          params.set(
            'filter.v.availability',
            '1'
          );

          window.location.assign(
            getSearchPath() + '?' +
            params.toString()
          );
        }
      );
    }
  }

  /* ============================
     GAME SELECTOR
     ============================ */

  function initializeGameSelector() {
    document.querySelectorAll(
      '[data-tct-game-select]'
    ).forEach(select => {

      select.addEventListener(
        'change',
        function () {
          const game = select.value;
          const type = GAME_TYPES[game];

          if (!type) {
            return;
          }

          const params = new URLSearchParams();

          params.set(
            'q',
            'product_type:' + quoteValue(type)
          );

          params.set('type', 'product');

          params.set('tct_game', game);

          params.set(
            'filter.p.product_type',
            type
          );

          params.set(
            'options[unavailable_products]',
            'hide'
          );

          params.set(
            'filter.v.availability',
            '1'
          );

          window.location.assign(
            getSearchPath() + '?' +
            params.toString()
          );
        }
      );

    });
  }

  /* ============================
     SORTING
     ============================ */

  function initializeSorting() {
    document.querySelectorAll(
      '[data-tct-sort]'
    ).forEach(select => {

      select.addEventListener(
        'change',
        function () {
          const url = new URL(
            window.location.href
          );

          const sortValue = select.value;

          if (sortValue) {
            url.searchParams.set(
              'sort_by',
              sortValue
            );
          } else {
            url.searchParams.delete(
              'sort_by'
            );
          }

          // Maintain stock restrictions.
          url.searchParams.set(
            'options[unavailable_products]',
            'hide'
          );

          url.searchParams.set(
            'filter.v.availability',
            '1'
          );

          // Start from first page.
          url.searchParams.delete('page');

          window.location.assign(
            url.toString()
          );
        }
      );

    });
  }

  /* ============================
     RESULTS PER PAGE
     ============================ */

  function initializePageSize() {
    document.querySelectorAll(
      '[data-tct-page-size]'
    ).forEach(select => {

      select.addEventListener(
        'change',
        function () {
          const url = new URL(
            window.location.href
          );

          const size = select.value;

          url.searchParams.delete('page');

          if (size === '24') {
            url.searchParams.delete('view');
          } else {
            url.searchParams.set(
              'view',
              size
            );
          }

          window.location.assign(
            url.toString()
          );
        }
      );

    });
  }

  /* ============================
     PAGINATION
     ============================ */

  function preservePaginationState() {
    const currentUrl = new URL(
      window.location.href
    );

    document.querySelectorAll(
      '[data-card-hall-pagination] a'
    ).forEach(link => {

      const linkUrl = new URL(
        link.href,
        window.location.origin
      );

      const page = linkUrl.searchParams.get(
        'page'
      );

      const nextUrl = new URL(
        currentUrl.href
      );

      if (page) {
        nextUrl.searchParams.set(
          'page',
          page
        );
      } else {
        nextUrl.searchParams.delete(
          'page'
        );
      }

      link.href = nextUrl.toString();
    });
  }

  /* ============================
     INITIALIZE
     ============================ */

  function initializeCardHallSearch() {
    document.querySelectorAll(
      '[data-card-hall-filter-form]'
    ).forEach(initializeFilterForm);

    initializeGameSelector();
    initializeSorting();
    initializePageSize();
    preservePaginationState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeCardHallSearch
    );
  } else {
    initializeCardHallSearch();
  }

})();

